import { createClass as _createClass, classCallCheck as _classCallCheck } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import { safeLocalStorage } from '../../storage.mjs';

var TypedStorage = /*#__PURE__*/function () {
  function TypedStorage(key) {
    var _options$storage;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, TypedStorage);

    this.key = key;
    this.storage = void 0;
    this.storage = (_options$storage = options.storage) !== null && _options$storage !== void 0 ? _options$storage : safeLocalStorage;

    if (options.initialValue != null && this.get() == null) {
      this.set(options.initialValue);
    }
  }

  _createClass(TypedStorage, [{
    key: "get",
    value: function get() {
      var value = this.storage.get(this.key);
      return value ? this.deserialize(value) : null;
    }
  }, {
    key: "set",
    value: function set(next) {
      this.storage.set(this.key, this.serialize(next));
    }
  }, {
    key: "clear",
    value: function clear() {
      this.storage.remove(this.key);
    }
  }, {
    key: "serialize",
    value: function serialize(value) {
      return JSON.stringify(value);
    }
  }, {
    key: "deserialize",
    value: function deserialize(value) {
      try {
        return JSON.parse(value);
      } catch (e) {
        return null;
      }
    }
  }]);

  return TypedStorage;
}();

export { TypedStorage };
